import {UI} from "../../../stem-core/src/ui/UIBase";

import {FlowController} from "./FlowController";
import {Messages} from "../../Messages";
import {iFrameMerchantService} from "../../services/IframeMerchantService";
import {startDonationFlow} from "./startFlow";

export class DonateFlowController extends FlowController {
    actionButtonTestId = "donateWithBlinkBtn";
    actionButtonDefaultAnid = "donate-button"; // TODO @branch remove this fucking shit anid and add data-analytics-panel-alias and data-analytics-panel-id in the DOM

    onClickAuthenticated() {
        startDonationFlow();
    }

    onClickNotAuthenticated() {
        startDonationFlow();
    }

    getHeaderDefaultText() {
        return super.getHeaderDefaultText() || Messages.donationPaywall(iFrameMerchantService.getMerchant().name);
    }

    getActionButtonDefaultLabel() {
        return super.getActionButtonDefaultLabel() || Messages.donate;
    }

    getLoginFooterMessage() {
        return Messages.alreadyDonor;
    }
}
